import { render, staticRenderFns } from "./ShiftVDP.vue?vue&type=template&id=73a2df7d&"
import script from "./ShiftVDP.vue?vue&type=script&lang=ts&"
export * from "./ShiftVDP.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftVDP.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports